import { z } from 'zod'

export const deadClickSchema = z.object({
  buttonText: z.string().nullable(),
  component: z.string().nullable(),
})
